export default {
  permutation(combArr) {
    let perm = []
    let set = new Set()

    function generate(perm, pre, post, n) {
      let elem
      let i
      let rest
      let len

      if (n > 0) {
        for (i = 0, len = post.length; i < len; ++i) {
          rest = post.slice(0)
          elem = rest.splice(i, 1)
          generate(perm, pre.concat(elem), rest, n - 1)
        }
      } else {
        let comb = pre.join('-')
        if (!set.has(comb)) {
          perm.push(pre)
          set.add(comb)
        }
      }
    }

    generate(perm, [], combArr, combArr.length)

    return perm
  }
}